export let logout = () => {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = "/portal/";
};
